const VERSION_LOCALSTORAGE_KEY = "version";
const apiVersion = process.env.API_VERSION || "1.0";
//console.log("index.tsx", "isDifferentVersion", await isDifferentVersion()); // might return true
//await storeCurrentVersion(); // when needs to store version
//console.log("index.tsx", "isDifferentVersion", await isDifferentVersion()); // should return false if previous line was executed
/** Returns true when localstorage stored version differs from the version of the app (from backend). Otherwise (including if user has no stored version) returns false. */
export function isDifferentVersion() {
    return getCurrentVersion() !== getUserVersion();
}
/** Store current version (from backend) into localstorage for the user */
export function storeCurrentVersion() {
    setUserVersion(getCurrentVersion());
}
function getCurrentVersion() {
    //return await commRequest("get", endPointToUrl(`/api/${apiVersion}/system/version`));
    const DWDASHBOARD_VERSION = process.env.DWDASHBOARD_VERSION || "";
    return DWDASHBOARD_VERSION;
}
function getUserVersion() {
    const storedUserVersion = localStorage.getItem(VERSION_LOCALSTORAGE_KEY);
    if (storedUserVersion === null) {
        return undefined;
    }
    else {
        return storedUserVersion;
    }
}
function setUserVersion(version) {
    localStorage.setItem(VERSION_LOCALSTORAGE_KEY, version);
}
